import React from 'react';
import styled from 'styled-components';
import { itvThemeColor, mobileMediaQuery } from '../../Theming';
import ItvLogo from '../Logos/ItvLogo';
import { Trans, useTranslation } from 'react-i18next';
import env from '../../env';
import { getYear } from 'date-fns';

interface FooterProps {
  text?: string;
}

const Container = styled.div`
  background-color: ${itvThemeColor('greenishBlue')};
  padding-top: 45px;
  padding-left: 19px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const TextContent = styled.span`
  color: ${itvThemeColor('textGray')};
  font-family: Arial;
  font-size: 15px;
  line-height: 25px;
  width: 70%;
`;

const ColoredTextContent = styled.a`
  color: ${itvThemeColor('lemonGreen')};
  cursor: pointer;
  text-decoration: none;
`;

const LogoContainer = styled.div`
  padding-top: 48px;
  padding-bottom: 84px;

  ${mobileMediaQuery} {
    padding-top: 38px;
    padding-bottom: 36px;
  }
`;

export const Footer: React.FC<FooterProps> = ({ text }) => {
  const { t } = useTranslation();
  return (
    <Container>
      <TextContent>
        <Trans
          t={t}
          values={{ year: getYear(new Date()) }}
          i18nKey={'extension.itvActivation.footer.policyText'}
        >
          <ColoredTextContent href={env.privacy_policy_url}>
            colored text
          </ColoredTextContent>
        </Trans>
      </TextContent>
      <LogoContainer>
        <ItvLogo width={102} height={34} />
      </LogoContainer>
    </Container>
  );
};
